import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'
import mutationRequirementsCheck from './mutation-requirements-check.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let [, executeMutationRequirementsCheck] = useMutation(
    mutationRequirementsCheck
  )

  return async function onSubmit({ value, change, args }) {
    let mutationRequirementsCheckResponse =
      await executeMutationRequirementsCheck({
        id: value.appointment_booking_id,
        params: { id: value.appointment_booking_id },
      })
    if (mutationRequirementsCheckResponse.error) {
      notify(
        notifyError('Cannot check out selected appointment. Please try again.')
      )
      return
    }

    if (
      mutationRequirementsCheckResponse.data
        .create_pre_appointment_bookings_state_update_automations.is_pending
    ) {
      // cannot unseat yet as some requirements need to be checked
      return
    }

    let mutationResponse = await executeMutation({
      id: value.appointment_booking_id,
    })

    if (
      mutationResponse.error ||
      mutationResponse.data.update_vaxiom_appointment_bookings.affected_rows ===
        0
    ) {
      notify(
        notifyError('Cannot check out selected appointment. Please try again.')
      )
      return
    }
  }
}
